import { mapPinType } from "../../constants/index.js";
import { handleChooseHotelRoomButtonClick } from "../../HotelComponent/ChooseHotelRoomButton.js";
const getMapPinOnClickHandler = (props)=>{
    if (props?.type === mapPinType.HOTEL) {
        const { hotel, args, hotelDetailsURL } = props;
        return handleChooseHotelRoomButtonClick({
            hotelId: hotel?.hotelId,
            args,
            detailURL: hotelDetailsURL || hotel?.hotelDetailsURL,
            clickedOnMap: 'Y'
        });
    }
    return ()=>{};
};
export { getMapPinOnClickHandler };
